import app from "flarum/common/app";

app.initializers.add("nearata-custom-captcha", () => {});
